module.exports = __webpack_public_path__ + "img/icon_db_2.6905ad95.svg";